import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function cursotipomonedaComboReducer(state= initialState.cursotipomonedaCombo, action){
	switch(action.type){
		case types.GET_CURSOTIPOMONEDAS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}